import { Routes } from '@angular/router';
import { ContentComponent } from './content/content.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { HelpPageComponent } from './help-page/help-page.component';
import { ContactComponent } from './contact/contact.component';

export const routes: Routes = [
  {
    path: '',
    component: ContentComponent,
  },
  {
    path: 'help',
    component: HelpPageComponent,
  },
  {
    path: 'contact',
    component: ContactComponent,
  },

  { path: '**', component: PageNotFoundComponent },
];
